import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags SectionTemplate
 */
export const DeleteSectionTemplateContentType = '' as const;
export type DeleteSectionTemplateRequest = void;
export type DeleteSectionTemplateResponses = LinkCommonErrorResponses & {
    /**
     * @description Section template deleted successfully
     */
    '200': {
        'application/json': unknown;
    };
};
export type DeleteSectionTemplateResponseSuccess = DeleteSectionTemplateResponses['200']['application/json'];
export type DeleteSectionTemplateSearchParams = undefined;
export type DeleteSectionTemplatePathParameters = {
    id: string;
};
export const DeleteSectionTemplateUrl = '/section_template/{id}' as const;
export const DeleteSectionTemplateMethod = 'DELETE' as const;
export const getDeleteSectionTemplateUrl = (params: DeleteSectionTemplatePathParameters) =>
    DeleteSectionTemplateUrl.replace(/\{(\w+)\}/g, (_match, param: keyof DeleteSectionTemplatePathParameters) =>
        String(params[param])
    );
